import * as runtime from '@/api/runtime'

/**
 * DAMファイルDL
 */
export class BatchReserveInfoExtractCsvApi extends runtime.BaseAPI {
  async return(): Promise<string> {
    const response = await this.requestGet(
      `/batch/reserve/reserve-info-extract-csv`
    )

    return new runtime.JSONApiResponse(
      response,
      jsonValue => jsonValue.url
    ).value()
  }
}
